export enum TableCellType {
  // if you change enum values, table styles for the particular type will be affected

  STRING = "string",
  DOC_STATUS = "doc-status",
  /** Like STRING but allows multi-line wrapping instead of single-line truncation */
  WRAPPED_STRING = "wrapped-string",
  BUTTON_LINK = "button-link",
  DATE = "date",
  STRING_LINK = "string-link",
  DOWNLOAD_BUTTON = "download-button",
  INFO = "info",
  MULTILINE = "multiline",
  COLORED_TEXT = "colored-text",
  BADGE = "badge",
  CLICKABLE_BADGE = "clickable-badge",
  CLICKABLE_BADGE_WITH_ON_CLICK = "clickable-badge-with-on-click",
  CLICKABLE_BADGE_FOR_FINAL_STATUS = "clickable-badge-for-final-status",
  CLICKABLE_BADGE_MODAL = "clickable-badge-modal",
  ICON = "icon",
  STRING_BADGE = "string-badge",
  ERROR_MODAL = "error-modal",
  COPY_DATA = "copy-data",
  USER_INITIALS = "user-initials",
  NYCBS_STATUS = "nycbs-status",
  DELETE_ICON = "delete-icon",
  EDIT_ICON = "edit-icon",
  CLICKABLE_TEXT_WITH_DISABLED_STATUS = "clickable-text-with-disabled-status",
  CHECKBOX = "checkbox",
  EDITABLE_TEXT = "editable-text",
  SELECTABLE_BADGE = "selectable-badge",
  BADGE_WITH_I = "badge-with-i",
  BADGE_WITH_STATUS_ICON = "badge-with-status-icon",
  THINKING_BUTTON = "thinking-button",
  STRING_WITH_BUTTON = "string-with-button",
  RPA_STATUS = "rpa-status",
  VIEW_ICON = "view-icon",
  DOC_NAME_WITH_ICON = "doc-name-with-icon",
  RPA_STATUS_TWO = "rpa-status-two",
  DOC_LIST = "doc-list",
  STRING_WITH_CUSTOM_TOOLTIP = "string-with-custom-tooltip",
  RPA_STATUS_FOR_EXTERNAL = "rpa-status-for-external",
  DOC_WITH_UPLOAD_ICON = "doc-with-upload-icon",
  VIEW_ICON_FOR_SCREENSHOT_OR_API_RESPONSE = "view-icon-for-screenshot-or-api-response",
  STRING_WITH_ICON = "string-with-icon",
  SIDE_MODAL_ICON = "side-modal-icon",
  TAG_WITH_ICON = "tag-with-icon",
  PDF_VIEWER_ICON = "pdf-viewer-icon",
  TOGGLE_SWITCH = "toggle-switch",
  TEXT_CELL_WITH_INPUT = "text-cell-with-input",
  EDIT_DELETE_ICONS = "edit-delete-icons",
  BADGE_GROUP = "badge-group",
  OVERLAPPING_ICONS_WITH_POPOVER_AND_ACTIONS = "overlapping-icons-with-popover-and-actions",
  IS_DOCUMENT_UPLOADED = "is-document-uploaded",
  SEARCHABLE_CARD = "searchable-card",
  /** Chevron toggle for opt-in expandable table rows. */
  EXPANDABLE_ROW_ICON = "expandable-row-icon",
}

/**
 * Column descriptor used by the table renderer.
 *
 * @property label - Human-readable column header text
 * @property key - Row-data key used to read the cell value
 * @property order - Render order of the column (lower renders first)
 * @property width - Column width as a percentage of the table width
 * @property sortable - When true, the column shows a sort affordance and participates in sorting
 * @property filterable - When true, the column participates in filter UI
 * @property sectionSearch - When true, the column is included in section-level search
 * @property type - Cell renderer type that drives how each cell is displayed
 * @property subKey - Optional nested key when the cell value lives under `row[key][subKey]`
 * @property sortField - Optional canonical backend field name emitted to consumers via
 *   `onSortTableClicked` and persisted to context as `sortByField`
 * @property hideHeaderCheckbox - When true on a CHECKBOX column, row checkboxes render but the
 *   header select-all checkbox is omitted
 */
export interface TableHeader {
  label: string;
  key: string;
  order: number;
  width: number;
  sortable?: boolean;
  filterable?: boolean;
  sectionSearch?: boolean;
  type: TableCellType;
  subKey?: string;
  sortField?: string;
  hideHeaderCheckbox?: boolean;
}

export interface CellData {
  type: TableCellType;
  value: any;
  width: number;
  header?: string;
  rowData?: any;
}
